export default "__VITE_ASSET__Cgpww0zD__"